import type { FormatLabelFn } from '@@partner:types:app'

import {
  ORDER_STATUS_REFUNDED,
  ORDER_STATUS_INITIAL,
  ORDER_STATUS_PLACED,
  ORDER_STATUS_CANCELED,
  ORDER_STATUS_PAID,
  ORDER_STATUS_WAITING_FOR_PAYMENT,
  ORDER_STATUS_ASSEMBLY_IN_PROGRESS,
  ORDER_STATUS_ASSEMBLY_COMPLETE,
  ORDER_STATUS_ACCEPTED_BY_COURIER,
  ORDER_STATUS_WAITING_FOR_COURIER,
  ORDER_STATUS_DEVIVERY_IN_PROGRESS,
  ORDER_STATUS_DELIVERED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_RECALL_CLIENT,
  ORDER_STATUS_WAITING_FOR_SLOT_CHANGE,
  ORDER_SLOT_CHANGED,
  ORDER_STATUS_WAITING_CONFIRMATION,
  ORDER_STATUS_WAITING_FOR_CUSTOMER,
  ORDER_STATUS_WAITING_FOR_POST_PAYMENT,
  ORDER_STATUS_POST_PAYMENT_PAID
} from '@@partner:config/order-status-codes'

/*
  Get order status label by status code
*/

export const formatOrderStatusLabel: FormatLabelFn = (value) => {
  switch (value) {
  case ORDER_STATUS_REFUNDED:
    return { label: 'Возврат', color: 'red' }
  case ORDER_STATUS_CANCELED:
    return { label: 'Отменён', color: 'red' }
  case ORDER_STATUS_INITIAL:
    return { label: 'Черновик', color: undefined }
  case ORDER_STATUS_PLACED:
    return { label: 'Размещён', color: 'green' }
  case ORDER_STATUS_PAID:
    return { label: 'Оплачен', color: 'green' }
  case ORDER_STATUS_WAITING_FOR_PAYMENT:
    return { label: 'Ожидает оплаты', color: 'yellow' }
  case ORDER_STATUS_ASSEMBLY_IN_PROGRESS:
    return { label: 'Собирается', color: 'violet' }
  case ORDER_STATUS_ASSEMBLY_COMPLETE:
    return { label: 'Собран', color: 'green' }
  case ORDER_STATUS_ACCEPTED_BY_COURIER:
    return { label: 'Курьер забрал заказ', color: 'violet' }
  case ORDER_STATUS_WAITING_FOR_CUSTOMER:
    return { label: 'Ожидает клиента', color: 'violet' }
  case ORDER_STATUS_WAITING_FOR_COURIER:
    return { label: 'Ожидает курьера', color: 'violet' }
  case ORDER_STATUS_WAITING_FOR_POST_PAYMENT:
    return { label: 'Ожидает оплаты', color: 'violet' }
  case ORDER_STATUS_POST_PAYMENT_PAID:
    return { label: 'Оплачен', color: 'green' }
  case ORDER_STATUS_DEVIVERY_IN_PROGRESS:
    return { label: 'Доставляется', color: 'violet' }
  case ORDER_STATUS_DELIVERED:
    return { label: 'Доставлен', color: 'green' }
  case ORDER_STATUS_COMPLETED:
    return { label: 'Завершён', color: 'green' }
  case ORDER_STATUS_RECALL_CLIENT:
    return { label: 'Не удалось связаться', color: 'red' }
  case ORDER_STATUS_WAITING_FOR_SLOT_CHANGE:
    return {
      label: 'Заказ требуется перенести, менеджер уведомлён',
      color: 'red'
    }
  case ORDER_SLOT_CHANGED:
    return { label: 'Заказ перенесён', color: 'blue' }
  case ORDER_STATUS_WAITING_CONFIRMATION:
    return { label: 'Ожидает оплаты', color: 'blue'}
  default:
    return {
      label: `Неопределённый статус ${status}`,
      color: 'red'
    }
  }
}
